export const DRAWER_WIDTH = 240;
export const DESKTOP_CONTAINER_MAX_WIDTH = 500;
